// How tall the dropdown of a custom select may grow when it hangs below its
// placeholder inside a fixed container (a modal), where the page cannot be
// scrolled to reveal the rest of it. Everything is a number handed in by the
// caller — the offset the popper adds between placeholder and dropdown, the
// padding kept from the viewport edge — so the rule stays testable and the DOM
// measuring lives in the view. Two bounds meet here: the dropdown never grows
// past its own content, and it never shrinks below minHeight, since a couple of
// visible options beat a sliver that fits perfectly.
export function dropdownMaxHeight({
  placeholderBottom,
  viewportHeight,
  contentHeight,
  offset = 4,
  padding = 10,
  minHeight = 150
}) {
  const spaceBelow = viewportHeight - placeholderBottom;

  return Math.min(Math.max(minHeight, spaceBelow - offset - padding), contentHeight);
}
